import React from "react";
import { has } from "lodash";
import { Row, Col, Label, Input } from "reactstrap";
import moment from "moment";
import { translate } from "../../../utils/i18n";

function NBIoTDownlinkParameters(props) {
  const { deviceForm, ability } = props;
  if (!deviceForm.device_model.mqtt || !deviceForm.device_model.mqtt.brokerNumber) return null;
  if (!ability || ability.cannot("update", "downlink-config")) return null;
  return (
    <React.Fragment>
      {/* MQTT parameters START  */}
      <div className="border rounded p-1 mt-3">
        <h4>{translate("downlink.sectionLabel")}</h4>
        <h5>{translate("downlink.aboveThresholdSectionLabel")}</h5>
        {/* miAbove & xtiAbove */}
        <Row className="mt-2">
          {/* Downlink miAbove */}
          <Col xs="12" md="6">
            <Label className="font-weight-bold">{translate("downlink.miAbove")}</Label>
            {props.isInEditMode ? (
              <Input
                type="number"
                id="miAbove"
                name="miAbove"
                onChange={(e) => props.handlePropertiesInputChange(e)}
                value={has(deviceForm, "properties.miAbove") ? deviceForm.properties.miAbove : ""}
                min="1"
                disabled={deviceForm.deleted}
              />
            ) : (
              <p>{has(deviceForm, "properties.miAbove") ? deviceForm.properties.miAbove : ""}</p>
            )}
          </Col>
          {/* Downlink xtiAbove */}
          <Col xs="12" md="6">
            <Label className="font-weight-bold">{translate("downlink.xtiAbove")}</Label>
            {props.isInEditMode ? (
              <Input
                type="number"
                id="xtiAbove"
                name="xtiAbove"
                onChange={(e) => props.handlePropertiesInputChange(e)}
                value={has(deviceForm, "properties.xtiAbove") ? deviceForm.properties.xtiAbove : ""}
              />
            ) : (
              <p>{has(deviceForm, "properties.xtiAbove") ? deviceForm.properties.xtiAbove : ""}</p>
            )}
          </Col>
        </Row>

        {/* Downlink thresholdValue */}
        <Row className="mt-2">
          <Col xs="12" md="12">
            <Label className="font-weight-bold">{translate("downlink.th")}</Label>
            {props.isInEditMode ? (
              <Input
                type="number"
                id="th"
                name="th"
                onChange={(e) => props.handlePropertiesInputChange(e)}
                value={has(deviceForm, "properties.th") ? deviceForm.properties.th : ""}
                disabled={deviceForm.deleted}
              />
            ) : (
              <p>{has(deviceForm, "properties.th") ? deviceForm.properties.th : ""}</p>
            )}
          </Col>
        </Row>

        {/* Section header: belowThresholdSectionLabel */}
        <Row className="mt-2">
          <Col xs="12" md="12">
            <h5>{translate("downlink.belowThresholdSectionLabel")}</h5>
          </Col>
        </Row>

        {/* Downlink miUnder & xtiUnder */}
        <Row className="mt-2">
          {/*  Downlink miUnder*/}
          <Col xs="12" md="6">
            <Label className="font-weight-bold">{translate("downlink.miUnder")}</Label>
            {props.isInEditMode ? (
              <Input
                type="number"
                id="miUnder"
                name="miUnder"
                onChange={(e) => props.handlePropertiesInputChange(e)}
                value={has(deviceForm, "properties.miUnder") ? deviceForm.properties.miUnder : ""}
                disabled={deviceForm.deleted}
                min="1"
              />
            ) : (
              <p>{has(deviceForm, "properties.miUnder") ? deviceForm.properties.miUnder : ""}</p>
            )}
          </Col>

          {/* Downlink xtiUnder */}
          <Col xs="12" md="6">
            <Label className="font-weight-bold">{translate("downlink.xtiUnder")}</Label>
            {props.isInEditMode ? (
              <Input
                type="number"
                id="xtiUnder"
                name="xtiUnder"
                min="1"
                onChange={(e) => props.handlePropertiesInputChange(e)}
                value={has(deviceForm, "properties.xtiUnder") ? deviceForm.properties.xtiUnder : ""}
                disabled={deviceForm.deleted}
              />
            ) : (
              <p>{has(deviceForm, "properties.xtiUnder") ? deviceForm.properties.xtiUnder : ""}</p>
            )}
          </Col>
        </Row>
        {deviceForm.properties?.appliedConfig ? (
          <React.Fragment>
            <Row className="mt-2">
              <Col xs="12" md="12">
                <h5>{translate("downlink.appliedConfig")}</h5>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs="12" md="3">
                <Label className="font-weight-bold">{translate("downlink.miUnder")}</Label>
                <p>{deviceForm.properties.appliedConfig.AcMI}</p>
              </Col>
              <Col xs="12" md="3">
                <Label className="font-weight-bold">{translate("downlink.xtiUnder")}</Label>
                <p>{deviceForm.properties.appliedConfig.AcXTI}</p>
              </Col>
              <Col xs="12" md="3">
                <Label className="font-weight-bold">{translate("downlink.th")}</Label>
                <p>{deviceForm.properties.appliedConfig.THVal}</p>
              </Col>
              <Col xs="12" md="3">
                <Label className="font-weight-bold">{translate("downlink.event")}</Label>
                <p>{deviceForm.properties.appliedConfig.EVENT}</p>
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="4">
                <Label className="font-weight-bold">{translate("downlink.messageCount")}</Label>
                <p>{deviceForm.properties.appliedConfig.MsgCnt}</p>
              </Col>

              <Col xs="12" md="4">
                <Label className="font-weight-bold">{translate("deviceType")}</Label>
                <p>{deviceForm.properties.appliedConfig.deviceType}</p>
              </Col>

              <Col xs="12" md="4">
                <Label className="font-weight-bold">{translate("downlink.appliedAt")}</Label>
                <p>{moment(deviceForm.properties.appliedConfig.time).format("LLL")}</p>
              </Col>
            </Row>
          </React.Fragment>
        ) : null}
      </div>
      {/* MQTT parameters END  */}
    </React.Fragment>
  );
}

export { NBIoTDownlinkParameters };
